import { render, staticRenderFns } from "./ImageGallery.vue?vue&type=template&id=38421aae&scoped=true"
import script from "./ImageGallery.vue?vue&type=script&setup=true&lang=ts"
export * from "./ImageGallery.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ImageGallery.vue?vue&type=style&index=0&id=38421aae&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38421aae",
  null
  
)

export default component.exports